import React from 'react';
import { Image, StyleSheet, Text, View } from '../base_components';

import CoinPrice from '../coin_price';
import CloseButton from '../buttons/close_button';
import WideButton from '../buttons/wide_button';
import ModalDialog from '../dialogs/modal_dialog';
import { Prize } from '../../data/prizes';
import CheckoutOverlay from './checkout_overlay';

import UserCurrencyStore from '../../stores/user_currency_store';

const styles = StyleSheet.create({
  prizeOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  close: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    height: '3em',
    width: '3em',
  },
  titleWrapper: {
    marginLeft: '2em',
    marginRight: '2em',
    marginBottom: '1em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
  image: {
    width: '15em',
    height: '15em',
    borderRadius: '1em',
  },
  price: {
    marginTop: '1em',
  },
  buyButton: {
    marginTop: '2em',
  },
});

type Props = {
  style?: any;
  prize: Prize;
  onDone: () => void;
};
type State = {
  show_checkout: boolean;
};

export default class PrizeOverlay extends React.PureComponent<Props, State> {
  state = {
    show_checkout: false,
  };
  _onBuyPress = () => {
    const balance = UserCurrencyStore.getBalance('dank_coin') || 0;
    const { prize } = this.props;
    const { coin_price } = prize;
    if (balance >= coin_price) {
      this.setState({ show_checkout: true });
    } else {
      ModalDialog.error(
        'Sorry, not enough Dank Coin, earn more and come back!'
      );
    }
  };
  _onCheckoutDone = () => this.setState({ show_checkout: false });

  render() {
    const { style, prize, onDone } = this.props;
    const { show_checkout } = this.state;
    const { display_name, image_url, coin_price } = prize;

    let content;
    if (show_checkout) {
      content = <CheckoutOverlay prize={prize} onDone={this._onCheckoutDone} />;
    } else {
      content = (
        <View style={[styles.prizeOverlay, style]}>
          <View style={styles.titleWrapper}>
            <Text style={styles.titleText}>{display_name}</Text>
          </View>
          <Image style={styles.image} source={image_url} />
          <CoinPrice
            style={styles.price}
            size='large'
            animated={true}
            price={coin_price}
          />
          <WideButton
            style={styles.buyButton}
            text='Buy Now'
            onPress={this._onBuyPress}
          />
          <CloseButton style={styles.close} onPress={onDone} />
        </View>
      );
    }
    return content;
  }
}
